import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from "@angular/router";

import { SinistroService } from '../services/sinistro.service';
import { AuthService } from '../services/auth.service';
import { ExcelService } from '../services/excel.service';
import { VeiculoService } from '../services/veiculo.service';
import { FiltroPipe } from '../pipes/filtro.pipe';
import Swal from 'sweetalert2';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';

@Component({
  selector: 'app-sinistro',
  templateUrl: './sinistro.component.html',
  styleUrls: ['./sinistro.component.css'],
  animations: [loadingFade, modal, alert]
})
export class SinistroComponent implements OnInit {

  public menu_id = 155;

  public loading = false;
  public sinistros = [];
  public veiculos = [];
  public img_extensions = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];

  // paginacao
  public page = 1;
  public limit = 10;
  public count = 0;

  // filtro
	public filtro = [];
	public dadosFiltrados = [];
	public formFiltro: FormGroup;
	public showFilter = true;

	//acesso
	public usuario_perfil;
	public visualizar = true;
	public editar = false;	  

  constructor(private fb: FormBuilder,
    private sinistroSvc: SinistroService,
    private authSvc: AuthService,
    private excelSvc: ExcelService,
    private veiculoSvc: VeiculoService,
    private perfilUsuarioSvc: PerfilUsuarioService,
    private router: Router,
    private route: ActivatedRoute
    ) { }

  ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		});  	

    this.loading = true;
    this.criaFiltro();
    this.pegaVeiculos();
    this.pegaTiposServico();
  }

  criaFiltro() {
		this.formFiltro = this.fb.group({
			sinistro_valor___valorMin: '',
			sinistro_valor___valorMax: '',
			sinistro_data___data_i: null,
			sinistro_data___data_f: null,
			veiculo_id___veiculo_id: null,
		});

		let campos_data = ['sinistro_data___data_i', 'sinistro_data___data_f'];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			Datepicker('#' + campo, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formFiltro.controls[campo].setValue(formatted);
				}
			});
		}
	}

  pegaTiposServico() {
    this.sinistroSvc.getSinistrosByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.sinistros = data;
      this.count = this.sinistros.length;
      this.loading = false;
    }).catch((err) => {
      this.loading = false;
      console.log(err);
    });
  }

  pegaVeiculos() {
    this.veiculoSvc.getVeiculosByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.veiculos = data;
      this.count = this.sinistros.length;
      this.loading = false;
    }).catch((err) => {
      this.loading = false;
      console.log(err);
    });
  }

  primPagina() {
    this.page = 1;
  }

  paginaAnt() {
    this.page = Math.max(this.page - 1, 1);
  }

  proxPagina() {
    this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
  }

  ultPagina() {
    this.page = Math.ceil(this.count / this.limit);
  }

  filtra() {
		this.filtro = this.formFiltro.value;
		this.dadosFiltrados = new FiltroPipe().transform(this.sinistros, this.filtro);
		this.count = this.dadosFiltrados.length;
		this.page = 1;
	}

  apagaSinistro(id) {
    Swal.fire({
      type: 'warning',
      title: 'Deseja realmente apagar este registro?',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Apagar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33'
    }).then((result) => {
      if (result.value == true) {
        this.sinistroSvc.apagaSinistro(id).then((data) => {
          this.pegaTiposServico();
          Swal.fire({
            type: 'success',
            title: 'Apagado com sucesso!'
          });
        }).catch((err) => {
          console.log(err);
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
          });
        });
      }
    })
  }

  tipo(tipo){
    switch (tipo) {
      case 'S':
        return 'Sinistro';
      case 'A':
        return 'Avaria';        
      default:
        return '';
    }
  }

  natureza(natureza){
    switch (natureza) {
      case 'P':
        return 'Próprio';
      case 'T':
        return 'Terceiro';        
      default:
        return '';
    }
  }

  openFile($id,typeFile){

    let col = "";

    if(typeFile == "boat"){
      col = "sinistro_boat";
    }else if(typeFile == "investigacao"){
      col = "sinistro_investigacao";
    }else if(typeFile == "doc_veiculo"){
      col = "sinistro_doc_veiculo";
    }else if(typeFile == "cnh"){
      col = "sinistro_cnh";
    }

		//this.loading = true;
		this.sinistroSvc.getSinistroArquivo($id,col).then((data) => {
		
			let dados = JSON.stringify(data);
			let obj = JSON.parse(dados);

      if(obj.nome == null){
        Swal.fire({
          type: 'error',
          title: 'Ops!',
          text: 'Não existe arquivo cadastrado!.'
        });
        return;
      }

			let objectURL = "";
			let tipo = obj.nome.substring(obj.nome.length - 3)
			
			if(tipo == "pdf"){
				 objectURL = 'data:application/pdf;base64,' + obj.arquivo;
			}else{
				 objectURL = 'data:image/jpeg;base64,' + obj.arquivo;
			}			

			const downloadLink = document.createElement('a');
			downloadLink.href = objectURL;
			downloadLink.download = "Documento_" + obj.sinistro_id;
			downloadLink.click();
			downloadLink.remove();

		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})



		/*if(file_name == null){
			Swal.fire({
				width: '100em',
				imageUrl: environment.serviceApi + '/downloader/notfound.png',
				imageAlt: 'arquivo'
			});
		}
		let file_ext = file_name.split('.')[1];

		if(this.img_extensions.includes(file_ext)){
			Swal.fire({
				width: '100em',
				imageUrl: environment.serviceApi + '/downloader/sinistros/' + file_name,
				imageAlt: 'arquivo'
			});
		}
		else{
			Swal.fire({
				html: '<a href="' + environment.serviceApi + '/downloader/sinistros/' + file_name + '"><i class="fa fa-download" style="font-size: 64px;"></i><br>Baixar</a>',
			});
		}*/


  }
  
  expandPanel(){
		this.showFilter = this.showFilter == true ? false: true;
	}

}
